import { useState } from "react";
import { ChevronLeft, ChevronRight, ImagePlus } from "lucide-react";

/**
 * ServiceGallery
 * Simple carousel used inside the Servicios page.
 * If no images are provided, renders 3 empty placeholder slots that
 * preserve the space and can be replaced later with real photos.
 */
export const ServiceGallery = ({ images = [], testid, altBase = "Galería" }) => {
  const slots = images.length > 0 ? images : [null, null, null];
  const [idx, setIdx] = useState(0);

  const prev = () => setIdx((i) => (i - 1 + slots.length) % slots.length);
  const next = () => setIdx((i) => (i + 1) % slots.length);

  return (
    <div
      data-testid={testid}
      className="relative w-full aspect-[4/3] md:aspect-[16/11] bg-[#eef1f4] rounded-2xl overflow-hidden group"
    >
      {/* Slides */}
      {slots.map((src, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity duration-500 ${
            i === idx ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          {src ? (
            <img
              src={src}
              alt={`${altBase} ${i + 1}`}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          ) : (
            <div className="w-full h-full flex flex-col items-center justify-center text-[#8f9194]/70 gap-2">
              <ImagePlus size={40} strokeWidth={1} />
              <span className="text-xs uppercase tracking-[0.25em] font-sans-modern">
                Imagen {i + 1}
              </span>
            </div>
          )}
        </div>
      ))}

      {/* Arrows */}
      {slots.length > 1 && (
        <>
          <button
            type="button"
            onClick={prev}
            data-testid={`${testid}-prev`}
            aria-label="Anterior"
            className="absolute left-3 md:left-4 top-1/2 -translate-y-1/2 h-10 w-10 md:h-11 md:w-11 rounded-full bg-white/80 hover:bg-white text-[#002438] flex items-center justify-center backdrop-blur-sm shadow-sm transition-all"
          >
            <ChevronLeft size={20} strokeWidth={1.5} />
          </button>
          <button
            type="button"
            onClick={next}
            data-testid={`${testid}-next`}
            aria-label="Siguiente"
            className="absolute right-3 md:right-4 top-1/2 -translate-y-1/2 h-10 w-10 md:h-11 md:w-11 rounded-full bg-white/80 hover:bg-white text-[#002438] flex items-center justify-center backdrop-blur-sm shadow-sm transition-all"
          >
            <ChevronRight size={20} strokeWidth={1.5} />
          </button>
        </>
      )}

      {/* Dots */}
      {slots.length > 1 && (
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
          {slots.map((_, i) => (
            <button
              key={i}
              type="button"
              onClick={() => setIdx(i)}
              data-testid={`${testid}-dot-${i}`}
              aria-label={`Ir a la imagen ${i + 1}`}
              className={`h-1.5 rounded-full transition-all ${
                i === idx ? "w-6 bg-white" : "w-1.5 bg-white/60 hover:bg-white/80"
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
};
